import React, { Component } from 'react';

class RightBox extends Component {

  render() {
    let currentActor = this.props.actors.inActors.find(actor => actor.id === this.props.actor);

    return (
      <div className="chat-box-right clear-all">
        <div className="chat-box-text">
          {this.props.children}
        </div>
        <div className="actor-img-name">
          <img src={currentActor.gravatar} className="chat-img"></img>
          <div>{currentActor.first_name}</div>
        </div>
        {/* <img src={this.props.selfActorImage} className="chat-img"></img> */}
      </div>
    );
  }
}

export default RightBox;



// WEBPACK FOOTER //
// /src/call/container/boxes/RightBox.js